export default "__VITE_ASSET__Ch8Ffpba__"